import { InvestmentFrequency, RecapItemsFragment } from 'generated/types'

import { currencyFormatterNoTrailingZeros } from '../helpers'
import { GiftType, PotentialType } from './types'

type ParsedDataType = {
  beneficiaryId: string
  beneficiaryName: string
  contributionByOthers: string
  custodianContribution: string
  custodianNickname: string
  endsAt: string
  gifts: GiftType[]
  investmentAccountId: string
  performance?: RecapItemsFragment['performance']
  publicEnabled: boolean
  publicUrl: string
  recapId: string
  startsAt: string
} & PotentialType

const DEFAULT_AGE_OF_TRANSFER = 18

export const parseRecapData = (
  data: RecapItemsFragment | undefined,
): ParsedDataType => {
  const {
    beneficiaryAge,
    beneficiaryCustodianNickname,
    beneficiaryFirstName,
    endsAt,
    id: recapId = '',
    investmentAccount,
    public: publicEnabled = false,
    publicUrl,
    startsAt,
  } = data || {}
  const beneficiaryId = investmentAccount?.beneficiaryId || ''
  const beneficiary = investmentAccount?.beneficiary
  const totalContributions = data?.totalContributions?.value ?? 0
  const contributionsByOthers = data?.totalContributionsByOthers?.value ?? 0
  const investmentAccountId = data?.investmentAccount?.id || ''
  // Common
  const custodianNickname =
    beneficiary?.custodianNickname || beneficiaryCustodianNickname || ''
  const beneficiaryName = beneficiaryFirstName || ''

  // Contributions section
  const custodianContributionAmount = totalContributions - contributionsByOthers

  // Gifts
  const contributionByOthersAmount = contributionsByOthers ?? 0
  const gifts: GiftType[] = (data?.contributionsByOthers || [])
    .map(({ contributorName, note }) => ({
      contributorName: contributorName || '',
      note: note || '',
    }))
    .slice(0, 6)

  // Perforamces
  const performance = data?.performance

  // Potential
  const ageOfTransfer =
    investmentAccount?.transferability?.transferAge || DEFAULT_AGE_OF_TRANSFER
  const currentBalance = data?.latestAccountValue?.value || 0
  const age = beneficiaryAge || 0
  const { amount, day, frequency } =
    data?.investmentAccount?.recurringInvestmentSettings || {}

  return {
    age,
    beneficiaryId,
    beneficiaryName,
    contributionByOthers: currencyFormatterNoTrailingZeros(
      contributionByOthersAmount,
    ),
    custodianContribution: currencyFormatterNoTrailingZeros(
      custodianContributionAmount,
    ),
    ageOfTransfer,
    currentBalance,
    custodianNickname,
    endsAt,
    gifts,
    investmentAccountId,
    performance,
    publicEnabled,
    publicUrl,
    recapId,
    recurringInvestmentSettings: {
      amount: amount ?? 0,
      day: day ?? 0,
      frequency: frequency ?? InvestmentFrequency.Monthly,
    },
    startsAt,
  }
}
